<template>
  <div class="children-box">
    <el-dialog
      title="选择商品分类"
      v-if="showDialog"
      center
      :visible.sync="dialogVisible"
      :before-close="goBack"
      width="70%"
    >
      <div class="select-box">
        <div>
          <el-row :gutter="10">
            <el-col :span="7">
              <div class="item-col">
                <span class="label">品类名称</span>
                <div>
                  <el-input
                    v-model="queryInfo.condition.categoryName"
                    style="width: 100%;"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </div></div
            ></el-col>
            <!-- <el-col :span="7">
              <div class="item-col">
                <span class="label">状态</span>
                <div>
                  <el-input
                    v-model="queryInfo.condition.putOn"
                    style="width: 100%;"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </div></div
            ></el-col> -->
            <el-col :span="5"
              ><el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                >查询</el-button
              >
              <el-button type="info" icon="el-icon-refresh" @click="reset"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div style="height: calc(85vh - 320px);overflow-y: auto;">
          <el-table
            :data="tableData" tooltip-effect="dark"
            height="100%"
            style="width: 100%"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column label="品类名称" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.categoryName }}</template>
            </el-table-column>
            <el-table-column label="商品品类图像" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-image
                    style="width: 60px; height: 60px"
                    :src="scope.row.logo"
                    :preview-src-list="[scope.row.logo]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
              </template>
            </el-table-column>
         <!--    <el-table-column label="级别" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.level==1?'一级分类':'二级分类' }}</template>
            </el-table-column>
            <el-table-column label="是否参加活动" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.isActivity==1?'是':'否' }}</template>
            </el-table-column>
            <el-table-column label="状态" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.putOn==1?'上架':'下架' }}</template>
            </el-table-column> -->
          </el-table>
        </div>
        <div style="display: flex;justify-content: flex-end;">
          <!-- 分页 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="queryInfo.currPage" :page-sizes="[20, 50, 100, 200, 500]" :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmselelct">确 定</el-button>
        <el-button @click="goBack">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor
  },
  props: {
    couponlist: {
        type: Array,
        default: ()=>[]
    },
    showDialog: {
        type: Boolean,
        default: ()=>false
    },
  },
  model: {
    prop: 'couponlist',
    event: 'changes'
  },
  data() {
    return {
      queryInfo: {
        condition: {
          categoryName: '',
          putOn: 1,
          level: 1,
        },
        currPage: 1,
        pageSize: 100
      },
      total: 0,
      tableData: [],
      goodsData: {
        count: 0,
        goodsList: []
      },
      selectTableList: [],
      changecouponlist:[],
      dialogVisible: false,
    };
  },
  watch: {
    showDialog:{
      handler(newVal){
        this.dialogVisible = !!(newVal)
        this.getCouponList()
      },
      deep:true
    },
  },
  async created() {
    // let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  mounted() {
    // if (this.dialogVisible) {
    //   this.getCouponList()
    // }
  },
  methods: {
    // 回显数据
    getCouponList() {
      var that = this;
      // productCategory/list
      that.queryInfo.condition.merchantCode = localStorage.getItem("merchantCode");
      that.$http.post("/merchantProductCategory/list", that.queryInfo).then(function (response) {
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data;
          // console.log('couponli---st',that.couponlist,that.showDialog)
        }
      });
    },
    // 全选
    handleSelectionChange(val) {
      this.selectTableList = val;
      // this.changecouponlist = this.couponlist.concat(val)
      console.log(val);
    },
    confirmselelct(){
      const that = this
      let _arr = []
      let hash = {};
      _arr = this.selectTableList.reduce(function(prev,cur,index,arr) {
          //把id作为键，如果键存在那么就不添加，否则就添加到数组里（prev为一个init默认数组）
          // hash[cur.id]判断对象的键是否存在，不存在为undefind
          if(that.couponlist.findIndex(item=>item.id == cur.id)>-1){}else{
            hash[cur.id] = true
            prev.push(cur)
          }
          // hash[cur.id] ? '' : hash[cur.id] = true && prev.push(cur);
          return prev
      }, [])
      this.couponlist.push(..._arr)
      console.log('?>?>//',this.couponlist,_arr)
      this.goBack()
    },
    goBack(done) {
      try{done()}catch(e){}
      this.$emit("goBack",this.changecouponlist);
    },
    search(){
      this.queryInfo.currPage = 1
      this.getCouponList()
    },
    reset(){
      this.queryInfo.condition = {
        categoryName: '',
        putOn: '',
        level: 1,
      }
      this.search()
    },
    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val;
      this.getCouponList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val;
      this.getCouponList()
    },
  }
};
</script>

<style lang="less" scoped>
.children-box {
}
.select-box {
  .item-col {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .label {
      margin-right: 10px;
    }
    div {
      flex: 1;
    }
  }
}
/deep/ .el-form {
  margin-top: 50px;
  .el-input {
    width: 300px;
  }
  .el-input-number {
    .el-input__inner {
      width: 100px;
    }
  }
}
</style>